import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, Container, Row, Col, Form, Table, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Auth, LoadingComponent } from 'recupero-comunes';
import { obtenerPretensionesImplicados, obtenerHistorialPretensiones } from '../../../../store/actions/gestion-defensa-action';
import { formatoMonto, formato_rut, minDate, money, reset_formato_monto, today, resetFormatoMonto } from './../../../../common/Formatos';
import { useFormik } from 'formik';
import { actualizarPretensiones, getCasoImplicado, getParametros } from '../../../../api/api-gestion-defensa';
import { validationSchemasPretension } from '../../../../common/validations-Schemas-pretension';
import Mensajes from '../../../mensajes';
import GrillaPretensionesImplicados from './grillaPretensionesImplicados'

const Pretensiones = ({ handleClose, idCaso, idImplicado, idOrganizacionCaso, setShowImplicados, setShowImplicadosHistorial }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
    const { llaves, cfg_form39, comboInstanciasPretensiones, comboPosibilidadesAcuerdo, listaPretensionesVigentes } = data_gestion_defensa;
    const { rutUsuario, monedaLocal } = Auth.currentUser();

    // Estados principales 
    const [montosCoberturas, setMontosCoberturas] = useState({});
    const [stateInstanciaPretencion, setStateInstanciaPretencion] = useState('');
    const [statePosibilidadAcuerdo, setStatePosibilidadAcuerdo] = useState('');
    const [stateFechaActualizacion, setStateFechaActualizacion] = useState(today());
    const [stateComentario, setStateComentario] = useState('');
    const [stateMontoTotal, setStateMontoTotal] = useState(0);
    const [parametro, setParametro] = useState('');
    const [involucrado, setInvolucrado] = useState({});
    const [fechaActualizaPretension, setFechaActualizaPretension] = useState('');
    const [fechaSiniestro, setFechaSiniestro] = useState('');
    const [responseData, setResponseData] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [dataSubmit, setDataSubmit] = useState({});
    const [showConfirm, setShowConfirm] = useState(false);
    const [showModalTotal, setShowModalTotal] = useState(false);

    const [showModalPretensionesImplicado, setShowModalPretensionesImplicado] = useState(false);
    const [dataReady, setDataReady] = useState(false);

    const [stateObsResponsable, setStateObsResponsable] = useState({});

  // Carga inicial de datos
  useEffect(() => {
    if (listaPretensionesVigentes) {
      setDataReady(false);
      let total = 0;
      const nuevosMontos = {};

      const nuevasObs = {};
      listaPretensionesVigentes?.listaPretensionesVigentes?.coberturasPoliza.forEach(pre => {
        const monto = pre.montoPretencion
        nuevosMontos[pre.codigoCobertura] = formatoMonto(monto, false);
        total += monto;
        nuevasObs[pre.codigoCobertura] = pre.obsResponsable || '';
      });

      setMontosCoberturas(nuevosMontos);
      setStateObsResponsable(nuevasObs);
      setStateMontoTotal(formatoMonto(total));

      const obtenerCasoImplicado = async () => {
        let query = Buffer.from(JSON.stringify({ idCaso, idImplicado })).toString('base64');
        const response = await getCasoImplicado(query);
        const ultimaPretension = response[0]?.ultimaPretension;

        setStateInstanciaPretencion(ultimaPretension?.CodInstancia || '');
        setStatePosibilidadAcuerdo(ultimaPretension?.CodPosibilidadAcuerdo || '');
        setFechaActualizaPretension(ultimaPretension?.FechaActualizacion);
        setStateComentario(ultimaPretension?.Comentario || '');
        setFechaSiniestro(response[0]?.FechaSiniestro);
        setInvolucrado({
          rut: response[0]?.RutInvolucrado,
          nombre: response[0]?.NombreInvolucrado,
          tipo: response[0]?.GlosaTipoInvolucrado,
          patente: response[0]?.Patente,
          lesionado: response[0]?.GlosaImplLesionado
        });
      };

      const obtenerParametros = async () => {
        let query = Buffer.from(JSON.stringify({ rutcia: 0, parametro: 35 })).toString('base64');
        const response = await getParametros(query);
        setParametro(response.valorParametro);
      };

      Promise.all([obtenerCasoImplicado(), obtenerParametros()]).finally(() => setDataReady(true));
    }
  }, [listaPretensionesVigentes]);

  const handleVerPretensionesImplicado = () => {
    if (llaves) {
      setLoading(true);
      setShowModalPretensionesImplicado(true);
      setShowImplicadosHistorial(false);
      let query = Buffer.from(JSON.stringify({ idCaso })).toString('base64');
      dispatch(obtenerPretensionesImplicados(query)).then(() => setLoading(false));
    }
  };

  const handleVerHistorialPretensiones = () => {
    if (llaves) {
      setLoading(true);
      setShowImplicadosHistorial(true);
      setShowModalPretensionesImplicado(false);
      let query = Buffer.from(JSON.stringify({ idCaso, idImplicado })).toString('base64');
      dispatch(obtenerHistorialPretensiones(query)).then(() => setLoading(false));
    }
  };

  const handleChangeObsResponsable = (codigoCobertura, value) => {
    setStateObsResponsable(prev => ({ ...prev, [codigoCobertura]: value }));
  };

  const recalculateTotal = () => {
    const total = Object.values(montosCoberturas)
      .map((m) => Number(reset_formato_monto(m)) || 0)
      .reduce((acc, val) => acc + val, 0);
    setStateMontoTotal(formatoMonto(total, false));
  };

  const handleCloseToast = () => {
    setShowToast(false);
    if (responseData?.code === 1) handleClose();
  };

  const updatePretensiones = async () => {
    setShowConfirm(false);
    setLoading(true);
    const response = await actualizarPretensiones(dataSubmit);
    setLoading(false);
    setResponseData(response.respuestaActPretensiones);
    setShowToast(true);
  };

  const formik = useFormik({
    initialValues: {
      idInstanciaPretensiones: '',
      idPosibilidadAcuerdo: '',
      fechaActualizacion: '',
      comentario: ''
    },
    validationSchema: validationSchemasPretension(fechaActualizaPretension, fechaSiniestro),
    onSubmit: async (data) => {
      const total = Number(resetFormatoMonto(stateMontoTotal));
      if (total <= 0) {
        setShowModalTotal(true);
        return;
      }

      const dataResult = {
        ...data,
        idCaso,
        idImplicadoCaso: idImplicado,
        idOrganizacion: idOrganizacionCaso,
        codMonedaLocal: 30001,
        idUsuario: rutUsuario,
        tipoMovimiento: 261001,
        idInstanciaProvision: data.idInstanciaPretensiones,
        codMonedaIngreso: 30001,
        fechaActualizacion: data.fechaActualizacion
          ? data.fechaActualizacion.split('-').join('')
          : ''
      };

      dataResult.coberturas = listaPretensionesVigentes?.listaPretensionesVigentes?.coberturasPoliza.map(pre => ({
        codigoCobertura: pre.codigoCobertura,
        codigoAmparoPadre: pre.codigoAmparoPadre,
        montoPretension: Number(reset_formato_monto(montosCoberturas[pre.codigoCobertura] || 0)),
        actualizaMonto: pre.actualizaMonto || "N",
        obsResponsable: stateObsResponsable[pre.codigoCobertura] || null,
      }));
      setDataSubmit(dataResult);
      setShowConfirm(true);
    }
  });
  const infoGrillaPretencion = listaPretensionesVigentes?.listaPretensionesVigentes?.coberturasPoliza?.[0] ?? null;

  return (
    <Fragment>
      <LoadingComponent show={loading} />
      <Card>
        <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
            {cfg_form39 ? cfg_form39.cfg_form39['modapretenciones-title-modal'] : ''}
        </Card.Header>

        <Container>
          {cfg_form39 ? (
            <>
            <fieldset disabled={!dataReady} style={{ border: 'none', padding: 0, margin: 0 }}>
            <Form onSubmit={formik.handleSubmit} className="mb-3">
              {/* Datos del involucrado */}
              <Container>
                <Row>
                  <Col md="2"><b>RUT:</b><br />{involucrado.rut && formato_rut(involucrado.rut)}</Col>
                  <Col md="3"><b>Nombre:</b><br />{involucrado.nombre}</Col>
                  <Col md="3"><b>Tipo:</b><br />{involucrado.tipo}</Col>
                  <Col md="2"><b>Patente:</b><br />{involucrado.patente}</Col>
                  <Col md="2"><b>Lesionado:</b><br />{involucrado.lesionado}</Col>
                </Row>
              </Container>

              <hr style={{ borderTop: '3px solid #04005D' }} />

              {/* Combos y campos principales */}
              <Container className="mb-4">
                <Row className="form">
                  <Col md="3">
                    <Form.Label className="is_required">Instancia</Form.Label>
                    <Form.Select
                      name="idInstanciaPretensiones"
                      onChange={(e) => { formik.handleChange(e); setStateInstanciaPretencion(e.target.value); }}
                      value={formik.values.idInstanciaPretensiones = stateInstanciaPretencion}
                    >
                      <option value="">Seleccione...</option>
                      {comboInstanciasPretensiones?.comboInstanciasPretensiones?.map((c) => (
                        <option key={c.id} value={c.id}>{c.nombre}</option>
                      ))}
                    </Form.Select>
                    {formik.errors.idInstanciaPretensiones && formik.touched.idInstanciaPretensiones &&
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.idInstanciaPretensiones}
                        </Form.Text>
                    }
                  </Col>

                  <Col md="3">
                    <Form.Label className="is_required">Posibilidad Acuerdo</Form.Label>
                    <Form.Select
                      name="idPosibilidadAcuerdo"
                      onChange={(e) => { formik.handleChange(e); setStatePosibilidadAcuerdo(e.target.value); }}
                      value={formik.values.idPosibilidadAcuerdo = statePosibilidadAcuerdo}
                    >
                      <option value="">Seleccione...</option>
                      {comboPosibilidadesAcuerdo?.comboPosibilidadesAcuerdo?.map((c) => (
                        <option key={c.id} value={c.id}>{c.nombre}</option>
                      ))}
                    </Form.Select>
                    {formik.errors.idPosibilidadAcuerdo && formik.touched.idPosibilidadAcuerdo &&
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.idPosibilidadAcuerdo}
                        </Form.Text>
                    }
                  </Col>

                  <Col md="3">
                    <Form.Label className="is_required">Fecha Actualización</Form.Label>
                    <Form.Control
                      type="date"
                      name="fechaActualizacion"
                      min={parametro && minDate(parametro)}
                      max={today()}
                      value={formik.values.fechaActualizacion = stateFechaActualizacion}
                      onChange={(e) => { formik.handleChange(e); setStateFechaActualizacion(e.target.value); }}
                    />
                     {formik.errors.fechaActualizacion && formik.touched.fechaActualizacion &&
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                              {formik.errors.fechaActualizacion}
                          </Form.Text>
                      }
                  </Col>

                  <Col md="9">
                    <Form.Label className="is_required">Comentario</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="comentario"
                      value={formik.values.comentario = stateComentario}
                      onChange={(e) => { formik.handleChange(e); setStateComentario(e.target.value); }}
                    />
                    {formik.errors.comentario && formik.touched.comentario &&
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.comentario}
                        </Form.Text>
                    }
                  </Col>
                </Row>
              </Container>

              {/* Tabla dinámica */}
              <Container>
                <div className="container_table">
                  <div className="container_table_header d-flex align-items-center">
                      <span className="me-3">{cfg_form39 && cfg_form39.cfg_form39["modapretenciones-title-grilla-vig"]}</span>
                      {infoGrillaPretencion && (
                          <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#d4d0f0' }}>
                              {infoGrillaPretencion.glosaEstado && <span className="me-3"><span style={{ opacity: 0.7 }}>Estado:</span> {infoGrillaPretencion.glosaEstado}</span>}
                              {infoGrillaPretencion.fechaRegistroFmt && <span className="me-3"><span style={{ opacity: 0.7 }}>Fecha Registro:</span> {infoGrillaPretencion.fechaRegistroFmt}</span>}
                              {infoGrillaPretencion.usuario && <span><span style={{ opacity: 0.7 }}>Usuario:</span> {infoGrillaPretencion.usuario}</span>}
                          </span>
                      )}
                  </div>

                  <Table striped bordered hover>
                    <thead>
                      <tr>
                          <th style={{ width: '25%' }}>{cfg_form39 && cfg_form39.cfg_form39["modapretenciones-grilla-cobertura"]}</th>
                          <th style={{ width: '160px' }}>{cfg_form39 && cfg_form39.cfg_form39["modapretenciones-grilla-monto"]} ({monedaLocal})</th>
                          <th>Observación Abogado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listaPretensionesVigentes?.listaPretensionesVigentes?.coberturasPoliza.map((pre) => {
                        const valorCampo = montosCoberturas[pre.codigoCobertura] || '';
                        return (
                          <tr key={pre.codigoCobertura}>
                            <td>{pre.cobertura}</td>
                            <td>
                              {pre.actualizaMonto === 'S' ? (
                                <Form.Control
                                  autoComplete="off"
                                  value={valorCampo}
                                  onChange={(e) => {
                                    const nuevoValor = e.target.value;
                                    setMontosCoberturas((prev) => ({
                                      ...prev,
                                      [pre.codigoCobertura]: nuevoValor
                                    }));
                                  }}
                                  onBlur={() => {
                                    const formateado = formatoMonto(valorCampo, false);
                                    setMontosCoberturas((prev) => ({
                                      ...prev,
                                      [pre.codigoCobertura]: formateado
                                    }));
                                    recalculateTotal();
                                  }}
                                  onFocus={() =>
                                    setMontosCoberturas((prev) => ({
                                      ...prev,
                                      [pre.codigoCobertura]: reset_formato_monto(prev[pre.codigoCobertura])
                                    }))
                                  }
                                  onKeyPress={(e) => money(e)}
                                />
                              ) : (
                                formatoMonto(pre.montoCobertura, false)
                              )}
                            </td>
                            <td>
                              <Form.Control
                                as="textarea"
                                rows={1}
                                value={stateObsResponsable[pre.codigoCobertura] || ''}
                                onChange={e => handleChangeObsResponsable(pre.codigoCobertura, e.target.value)}
                                maxLength={500}
                                style={{ resize: 'none', width: '100%', fontSize: '15px' }}
                              />
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td><strong>Total Pretensiones</strong></td>
                        <td colSpan={3}><strong>{stateMontoTotal} {monedaLocal}</strong></td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Container>

              {/* Botones */}
              <hr style={{ borderTop: '3px solid #04005D' }} />
              <Container>
                  <Row>
                      <Col className='d-flex align-items-end justify-content-end m-2 p-0'>
                          <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}>
                              {cfg_form39 && cfg_form39.cfg_form39["modapretenciones-btn-volver"]}
                          </Button>
                          <Button className='m-2' variant='verGrilla' onClick={handleVerPretensionesImplicado} name='buscar'>
                              {cfg_form39 && cfg_form39.cfg_form39["modapretenciones-btn-implicados"]}
                          </Button>
                          <Button className='m-2' variant='verGrilla' onClick={handleVerHistorialPretensiones} name='buscar'>
                              {cfg_form39 && cfg_form39.cfg_form39["modapretenciones-btn-historial"]}
                          </Button>
                          <Button type="submit" className='m-2' variant='actualizar' name='buscar'>
                              {cfg_form39 && cfg_form39.cfg_form39["modapretenciones-btn-actualziar"]}
                          </Button>
                      </Col>
                  </Row>
              </Container>

              {showToast && (
                <Mensajes
                  showToast={showToast}
                  handleCloseToast={handleCloseToast}
                  delay={5000}
                  responseData={responseData}
                />
              )}
            </Form>
            </fieldset>
            </>
          ) : (
            <p>Cargando configuración...</p>
          )}
        </Container>
      </Card>

      {/* Modal Confirmación */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} size="md">
        <Card>
          <Card.Header as="h6" style={{ backgroundColor: '#4F517A', color: 'white' }}>Confirmación</Card.Header>
          <Card.Body>¿Confirma nuevas pretensiones al implicado del caso en referencia?</Card.Body>
          <Card.Footer className="d-flex justify-content-center">
            <Button variant="outline-info" className="m-2" onClick={() => setShowConfirm(false)}>No</Button>
            <Button variant="danger" className="m-2" onClick={updatePretensiones}>Sí</Button>
          </Card.Footer>
        </Card>
      </Modal>

      {/* Modal Total */}
      <Modal show={showModalTotal} onHide={() => setShowModalTotal(false)} size="md">
        <Card>
          <Card.Header as="h6" style={{ backgroundColor: '#e8761a', color: 'white' }}>Información</Card.Header>
          <Card.Body>El monto total de pretensiones debe ser mayor a 0.</Card.Body>
          <Card.Footer className="d-flex justify-content-center">
            <Button variant="outline-info" onClick={() => setShowModalTotal(false)}>Cerrar</Button>
          </Card.Footer>
        </Card>
      </Modal>
      {showModalPretensionesImplicado &&
          <GrillaPretensionesImplicados
              setShowModalPretensionesImplicado={setShowModalPretensionesImplicado}
              showModalPretensionesImplicado={showModalPretensionesImplicado}                    
          />
      }
      <style type='text/css'>
          {`
              .btn-verGrilla {
                  background-color: #55B2CE;
                  color: #FFFFFF;
                  width: 168px;
              }
              .btn-verGrilla:hover{
                  background-color: #87c9dc;
                  color: #FFFFFF;
              }
              .is_required:after {
                  content: "(*)";
                  margin-left: 2px;
                  color: #000;
                  font-weight: 500;
                  font-size: 12pt;
              }
              .container_table span {
                  color: white;
              }
              .container_table_header {
                  padding: 10px 20px;
                  background-color: #716e9e;
                  border-top-left-radius: 5px;
                  border-top-right-radius: 5px;
              }
              .form {
                  margin-top: 5px;
              }                    
              .form label {
                  font-weight: bold;
                  font-size: 14px;
                  margin-bottom: 0;
                  margin-top: 5px
              }
          `}
      </style>
    </Fragment>
  );
};

export default Pretensiones;
